var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2225 8.25342H2.36914C2.02414 8.25342 1.74414 7.97342 1.74414 7.62842C1.74414 7.28342 2.02414 7.00342 2.36914 7.00342H17.2225C17.5675 7.00342 17.8475 7.28342 17.8475 7.62842C17.8475 7.97342 17.5675 8.25342 17.2225 8.25342Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 11.5078C13.1564 11.5078 12.873 11.2278 12.873 10.8828C12.873 10.5378 13.1489 10.2578 13.4939 10.2578H13.5014C13.8464 10.2578 14.1264 10.5378 14.1264 10.8828C14.1264 11.2278 13.8464 11.5078 13.5014 11.5078Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80314 11.5078C9.45814 11.5078 9.1748 11.2278 9.1748 10.8828C9.1748 10.5378 9.45064 10.2578 9.79564 10.2578H9.80314C10.1481 10.2578 10.4281 10.5378 10.4281 10.8828C10.4281 11.2278 10.1481 11.5078 9.80314 11.5078Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09792 11.5078C5.75292 11.5078 5.46875 11.2278 5.46875 10.8828C5.46875 10.5378 5.74542 10.2578 6.09042 10.2578H6.09792C6.44292 10.2578 6.72292 10.5378 6.72292 10.8828C6.72292 11.2278 6.44292 11.5078 6.09792 11.5078Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 14.7468C13.1564 14.7468 12.873 14.4668 12.873 14.1218C12.873 13.7768 13.1489 13.4968 13.4939 13.4968H13.5014C13.8464 13.4968 14.1264 13.7768 14.1264 14.1218C14.1264 14.4668 13.8464 14.7468 13.5014 14.7468Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80314 14.7468C9.45814 14.7468 9.1748 14.4668 9.1748 14.1218C9.1748 13.7768 9.45064 13.4968 9.79564 13.4968H9.80314C10.1481 13.4968 10.4281 13.7768 10.4281 14.1218C10.4281 14.4668 10.1481 14.7468 9.80314 14.7468Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09792 14.7468C5.75292 14.7468 5.46875 14.4668 5.46875 14.1218C5.46875 13.7768 5.74542 13.4968 6.09042 13.4968H6.09792C6.44292 13.4968 6.72292 13.7768 6.72292 14.1218C6.72292 14.4668 6.44292 14.7468 6.09792 14.7468Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1611 4.82575C12.8161 4.82575 12.5361 4.54575 12.5361 4.20075V1.45825C12.5361 1.11325 12.8161 0.833252 13.1611 0.833252C13.5061 0.833252 13.7861 1.11325 13.7861 1.45825V4.20075C13.7861 4.54575 13.5061 4.82575 13.1611 4.82575Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42969 4.82575C6.08469 4.82575 5.80469 4.54575 5.80469 4.20075V1.45825C5.80469 1.11325 6.08469 0.833252 6.42969 0.833252C6.77469 0.833252 7.05469 1.11325 7.05469 1.45825V4.20075C7.05469 4.54575 6.77469 4.82575 6.42969 4.82575Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1151_3163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 17,
    height: 17
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 2.14917H17.917V18.7499H1.66699V2.14917Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1151_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26782 3.39918C4.10699 3.39918 2.91699 4.55168 2.91699 6.64418V14.185C2.91699 16.3233 4.10699 17.5 6.26782 17.5H13.3162C15.477 17.5 16.667 16.345 16.667 14.2483V6.64418C16.6703 5.61501 16.3937 4.81501 15.8445 4.26501C15.2795 3.69834 14.4087 3.39918 13.3237 3.39918H6.26782ZM13.3162 18.75H6.26783C3.43033 18.75 1.66699 17.0008 1.66699 14.185V6.64417C1.66699 3.87084 3.43033 2.14917 6.26783 2.14917H13.3237C14.7478 2.14917 15.9253 2.57584 16.7295 3.38167C17.5103 4.16584 17.9212 5.29334 17.917 6.64584V14.2483C17.917 17.025 16.1537 18.75 13.3162 18.75Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dfad6b7ba5bda1e39f32d135399c3ee2.svg";
export { ForwardRef as ReactComponent };